module.exports = __webpack_public_path__ + "img/doctor@2x.b1b06911.png";